import React from 'react';
import { CheckCircle2, BookOpen, Gift, Star } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <section className="pt-16 pb-10 px-4 md:pt-32 md:pb-24 bg-spice-50 relative overflow-hidden" data-id="element-117">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-118">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-spice-300 rounded-full blur-3xl" data-id="element-119"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-spice-400 rounded-full blur-3xl" data-id="element-120"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-122">
          <div className="space-y-4 md:space-y-6 text-center lg:text-left" data-id="element-123">
            <div className="inline-flex items-center space-x-1 bg-spice-100 text-spice-800 px-3 py-1 rounded-full text-sm font-semibold border border-spice-200" data-id="element-124">
              <div className="flex text-spice-500" data-id="element-125">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-126" />)}
              </div>
              <span className="ml-2" data-id="element-127">Más de 923 alumnas</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 leading-tight" data-id="element-128">
              Hacé Tus Primeros{' '}
              <span className="text-spice-700 border-b-4 border-spice-400" data-id="element-129">
                $270.000
              </span>{' '}
              Vendiendo Condimentos Caseros con 60+ Recetas Probadas
            </h1>

            <p className="md:text-xl text-gray-700 text-[16px]" data-id="element-130">
              Descubrí EXACTAMENTE qué recetas venden más, cómo poner tus
              precios sin miedo y{' '}
              <strong data-id="element-131">conseguí tus primeros clientes</strong> por WhatsApp con
              este sistema completo de más de 200 páginas.
            </p>

            {/* Product Image - ABOVE trust badges on mobile */}
            <div className="relative mx-auto w-full max-w-[240px] md:max-w-xs lg:hidden" data-id="element-132">
              <div className="aspect-[3/4] md:aspect-[4/5] rounded-2xl shadow-2xl overflow-hidden relative ring-4 ring-amber-400 border-[6px] border-amber-100" style={{
              boxShadow: '0 0 30px rgba(217, 170, 60, 0.4), 0 25px 50px -12px rgba(0, 0, 0, 0.25)'
            }} data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/mGzw9fJFPX5EWFqjMrw8mv/portada_(1).jpg" alt="La Biblia de los Condimentos Caseros" className="absolute inset-0 w-full h-full object-cover" data-id="element-134" />
                <div className="absolute top-3 right-3 bg-urgency-500 text-white font-bold px-3 py-1.5 rounded-full shadow-lg transform rotate-12 text-xs" data-id="element-135">
                  ¡OFERTA HOY!
                </div>
              </div>
            </div>

            {/* Trust Badges - single line, scrollable on very small screens */}
            <div className="flex justify-center lg:justify-start gap-1.5 md:gap-3 text-[10px] md:text-sm font-medium text-gray-800 flex-nowrap overflow-x-auto" data-id="element-136">
              <div className="flex items-center bg-white px-2 md:px-4 py-1.5 md:py-2 rounded-lg shadow-sm border border-spice-100 whitespace-nowrap" data-id="element-137">
                +60 Recetas
              </div>
              <div className="flex items-center bg-white px-2 md:px-4 py-1.5 md:py-2 rounded-lg shadow-sm border border-spice-100 whitespace-nowrap" data-id="element-138">
                +8 Bonos
              </div>
              <div className="flex items-center bg-white px-2 md:px-4 py-1.5 md:py-2 rounded-lg shadow-sm border border-spice-100 whitespace-nowrap" data-id="element-139">
                <BookOpen className="w-3.5 h-3.5 md:w-5 md:h-5 text-spice-700 mr-1" data-id="element-140" />
                200+ Págs
              </div>
            </div>

            <div className="flex flex-col items-center lg:items-start space-y-3 md:space-y-4" data-id="element-141">
              <CtaButton text="QUIERO MI BIBLIA AHORA »" data-id="element-142" />
              <p className="text-sm text-gray-500 flex items-center justify-center space-x-2" data-id="element-143">
                <span data-id="element-144">Descarga inmediata</span>
                <span data-id="element-145">•</span>
                <span data-id="element-146">Pago único</span>
                <span data-id="element-147">•</span>
                <span data-id="element-148">Garantía 30 días</span>
              </p>
            </div>
          </div>

          {/* Desktop Image - right column */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-full hidden lg:block" data-id="element-149">
            <div className="aspect-[4/5] rounded-2xl shadow-2xl overflow-hidden relative transform rotate-2 hover:rotate-0 transition-transform duration-500 ring-4 ring-amber-400 border-[6px] border-amber-100" style={{
            boxShadow: '0 0 40px rgba(217, 170, 60, 0.4), 0 25px 50px -12px rgba(0, 0, 0, 0.25)'
          }} data-id="element-150">
              <img src="https://cdn.magicpatterns.com/uploads/mGzw9fJFPX5EWFqjMrw8mv/portada_(1).jpg" alt="La Biblia de los Condimentos Caseros" className="absolute inset-0 w-full h-full object-cover" data-id="element-151" />
              <div className="absolute top-4 right-4 bg-urgency-500 text-white font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-152">
                ¡OFERTA HOY!
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}